<template>
  <Transition name="imageappear" appear>
    <img
      v-if="srcset.length > 0"
      :srcset="srcset.map((s) => `${s.src} ${s.size}w`).join(', ')"
      :sizes="props.sizes"
      :alt="props.alt"
    />
  </Transition>
</template>

<script setup lang="ts">
import { expandThumb } from "@paparazzi/components/stores/thumbnail_conversion";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    images: any;
    alt: string;
    cropped?: boolean;
    sizes?: string;
  }>(),
  { sizes: "250px" },
);

const srcset = computed(() => {
  const expanded: { [key: string]: string } = {};
  for (const key in props.images) {
    expanded[key] = expandThumb(props.images[key]);
  }
  if (expanded) {
    const imgs: { src: string; size: number }[] = [];
    if (!props.cropped) {
      for (const size of [500, 250, 125]) {
        if (expanded[`w${size}`]) {
          imgs.push({ src: expanded[`w${size}`], size: size });
        }
      }
    } else {
      for (const size of [512, 100, 25]) {
        if (expanded[`cropped_${size}`]) {
          imgs.push({ src: expanded[`cropped_${size}`], size: size });
        } else if (expanded[`${size}_cropped`]) {
          imgs.push({ src: expanded[`${size}_cropped`], size: size });
        }
      }
    }
    if (expanded.original) {
      imgs.push({ src: expanded.original, size: 1000 });
    }
    if (imgs.length > 0) {
      return imgs;
    }
  }
  console.warn("no images to return");
  return [];
});
</script>

<style scoped>
img {
  max-width: 100%;
  object-fit: cover;
}
img.loader {
  object-fit: contain;
  height: 64px;
  width: 64px;
  margin: auto;
}
</style>
